import React from "react";
import { UserIdVerificationOverview } from "@limitless/portal";
import { useExpertOnboardingIdVerification } from "@limitless/expert";
import { useTranslation } from "@limitless/common/hooks";
import { usePageViewRecorder } from "@limitless/analytics";
import { ThemeProvider } from "@mui/material/styles";
import useCustomTheme from "../../utils/hooks/useCustomTheme";

const ExpertOnboardingIdVerificationOverview = () => {
    const { t } = useTranslation();
    const { getExpertProfileFields, ...rest } = useExpertOnboardingIdVerification(t);
    usePageViewRecorder("Onboarding - ID Verification");
    const theme = useCustomTheme();
    React.useEffect(() => getExpertProfileFields(), []);

    return (
        <ThemeProvider theme={theme}>
            <UserIdVerificationOverview {...rest} />
        </ThemeProvider>
    );
};

export default ExpertOnboardingIdVerificationOverview;
